import React from "react";

function AuthRight() {
    return (
        <div className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center">
            <div className="text-center px-4">
                <h2 className="mb-4">Welcome Back</h2>
                <p className="text-muted mb-4">Access your account to manage your trading activities, view your portfolio, and stay updated with the latest market trends.</p>
                <div className="mt-5">
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--primary-color)' }}>
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <div className="text-start">
                            <h6 className="mb-0">Secure & Protected</h6>
                            <small className="text-muted">Your data is encrypted and secure</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--primary-color)' }}>
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <div className="text-start">
                            <h6 className="mb-0">24/7 Access</h6>
                            <small className="text-muted">Manage your account anytime, anywhere</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--primary-color)' }}>
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <div className="text-start">
                            <h6 className="mb-0">Real-time Updates</h6>
                            <small className="text-muted">Get instant notifications and market alerts</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthRight;